module.exports = __webpack_public_path__ + "img/search_button_search_up.fb6fb018.png";